import { ThemeProvider } from "@emotion/react";
import { createTheme, TextField } from "@mui/material";
import React from "react";
import { colors } from "../../common/pallette/colors";

export const TextFieldWithoutBorders = (props:any) => {
    const { value, handleChange, placeholder, manageOnBlur, fontSize, fontWeight, fullWidth, isReadOnly, type, bg  } = props;
    const theme = createTheme({
      components: {
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-focused": {
                backgroundColor: colors.grey.bright,
              },
              color: colors.black.dark,
              backgroundColor: bg ? bg : "transparent"
            },
            input: {
                padding: '6px',
                fontSize: fontSize ? fontSize : '12px',
                fontWeight: fontWeight ? fontWeight : 400,
                color: colors.black.dark,
            }
          },
        },
      },
    });
    
    return(
        <ThemeProvider theme={theme}>
            <TextField
            sx={{ // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                    '& .MuiInputBase-input.Mui-disabled': {
                    WebkitTextFillColor: 'black', // Makes the input text black
                    cursor: isReadOnly ? 'not-allowed' : 'text'
                    }}}
            fullWidth={fullWidth}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            onBlur={manageOnBlur}
            disabled={isReadOnly}
            type={type}
            />
        </ThemeProvider>
    )
}